module.exports = __webpack_public_path__ + "img/globalx.8135f700.png";